/**
 * Standard/official Indian state and union-territory names in the app's
 * six supported regional languages. These are the established forms used
 * on Indian government multilingual portals and in-language references,
 * not machine-generated or invented transliterations.
 *
 * Keyed by the canonical English name exactly as stored in Supabase
 * (mi_mills.source_state / mi_v_*.canonical_state). Extra entries for
 * states/UTs not currently present in the live data are harmless and
 * future-proof the table against new data without another edit.
 */
export const STATE_NAME_TRANSLATIONS = {
  'Andaman and Nicobar': {
    hi: 'अंडमान और निकोबार द्वीप समूह',
    mr: 'अंदमान आणि निकोबार बेटे',
    gu: 'આંદામાન અને નિકોબાર ટાપુઓ',
    ta: 'அந்தமான் நிக்கோபார் தீவுகள்',
    te: 'అండమాన్ నికోబార్ దీవులు',
    kn: 'ಅಂಡಮಾನ್ ಮತ್ತು ನಿಕೋಬಾರ್ ದ್ವೀಪಗಳು',
  },
  'Andaman and Nicobar Islands': {
    hi: 'अंडमान और निकोबार द्वीप समूह',
    mr: 'अंदमान आणि निकोबार बेटे',
    gu: 'આંદામાન અને નિકોબાર ટાપુઓ',
    ta: 'அந்தமான் நிக்கோபார் தீவுகள்',
    te: 'అండమాన్ నికోబార్ దీవులు',
    kn: 'ಅಂಡಮಾನ್ ಮತ್ತು ನಿಕೋಬಾರ್ ದ್ವೀಪಗಳು',
  },
  'Andhra Pradesh': {
    hi: 'आंध्र प्रदेश', mr: 'आंध्र प्रदेश', gu: 'આંધ્ર પ્રદેશ',
    ta: 'ஆந்திரப் பிரதேசம்', te: 'ఆంధ్రప్రదేశ్', kn: 'ಆಂಧ್ರ ಪ್ರದೇಶ',
  },
  'Arunachal Pradesh': {
    hi: 'अरुणाचल प्रदेश', mr: 'अरुणाचल प्रदेश', gu: 'અરુણાચલ પ્રદેશ',
    ta: 'அருணாசலப் பிரதேசம்', te: 'అరుణాచల్ ప్రదేశ్', kn: 'ಅರುಣಾಚಲ ಪ್ರದೇಶ',
  },
  Assam: {
    hi: 'असम', mr: 'आसाम', gu: 'આસામ',
    ta: 'அசாம்', te: 'అస్సాం', kn: 'ಅಸ್ಸಾಂ',
  },
  Bihar: {
    hi: 'बिहार', mr: 'बिहार', gu: 'બિહાર',
    ta: 'பீகார்', te: 'బీహార్', kn: 'ಬಿಹಾರ',
  },
  Chhattisgarh: {
    hi: 'छत्तीसगढ़', mr: 'छत्तीसगड', gu: 'છત્તીસગઢ',
    ta: 'சத்தீஸ்கர்', te: 'ఛత్తీస్‌గఢ్', kn: 'ಛತ್ತೀಸ್‌ಗಢ',
  },
  Goa: {
    hi: 'गोवा', mr: 'गोवा', gu: 'ગોવા',
    ta: 'கோவா', te: 'గోవా', kn: 'ಗೋವಾ',
  },
  Gujarat: {
    hi: 'गुजरात', mr: 'गुजरात', gu: 'ગુજરાત',
    ta: 'குஜராத்', te: 'గుజరాత్', kn: 'ಗುಜರಾತ್',
  },
  Haryana: {
    hi: 'हरियाणा', mr: 'हरियाणा', gu: 'હરિયાણા',
    ta: 'ஹரியானா', te: 'హర్యానా', kn: 'ಹರಿಯಾಣ',
  },
  'Himachal Pradesh': {
    hi: 'हिमाचल प्रदेश', mr: 'हिमाचल प्रदेश', gu: 'હિમાચલ પ્રદેશ',
    ta: 'இமாச்சலப் பிரதேசம்', te: 'హిమాచల్ ప్రదేశ్', kn: 'ಹಿಮಾಚಲ ಪ್ರದೇಶ',
  },
  Jharkhand: {
    hi: 'झारखंड', mr: 'झारखंड', gu: 'ઝારખંડ',
    ta: 'ஜார்க்கண்ட்', te: 'జార్ఖండ్', kn: 'ಜಾರ್ಖಂಡ್',
  },
  Karnataka: {
    hi: 'कर्नाटक', mr: 'कर्नाटक', gu: 'કર્ણાટક',
    ta: 'கர்நாடகா', te: 'కర్ణాటక', kn: 'ಕರ್ನಾಟಕ',
  },
  Kerala: {
    hi: 'केरल', mr: 'केरळ', gu: 'કેરળ',
    ta: 'கேரளா', te: 'కేరళ', kn: 'ಕೇರಳ',
  },
  'Madhya Pradesh': {
    hi: 'मध्य प्रदेश', mr: 'मध्य प्रदेश', gu: 'મધ્ય પ્રદેશ',
    ta: 'மத்தியப் பிரதேசம்', te: 'మధ్యప్రదేశ్', kn: 'ಮಧ್ಯ ಪ್ರದೇಶ',
  },
  Maharashtra: {
    hi: 'महाराष्ट्र', mr: 'महाराष्ट्र', gu: 'મહારાષ્ટ્ર',
    ta: 'மகாராஷ்டிரா', te: 'మహారాష్ట్ర', kn: 'ಮಹಾರಾಷ್ಟ್ರ',
  },
  Manipur: {
    hi: 'मणिपुर', mr: 'मणिपूर', gu: 'મણિપુર',
    ta: 'மணிப்பூர்', te: 'మణిపూర్', kn: 'ಮಣಿಪುರ',
  },
  Meghalaya: {
    hi: 'मेघालय', mr: 'मेघालय', gu: 'મેઘાલય',
    ta: 'மேகாலயா', te: 'మేఘాలయ', kn: 'ಮೇಘಾಲಯ',
  },
  Mizoram: {
    hi: 'मिजोरम', mr: 'मिझोराम', gu: 'મિઝોરમ',
    ta: 'மிசோரம்', te: 'మిజోరం', kn: 'ಮಿಜೋರಾಂ',
  },
  Nagaland: {
    hi: 'नागालैंड', mr: 'नागालँड', gu: 'નાગાલેન્ડ',
    ta: 'நாகாலாந்து', te: 'నాగాలాండ్', kn: 'ನಾಗಾಲ್ಯಾಂಡ್',
  },
  Odisha: {
    hi: 'ओडिशा', mr: 'ओडिशा', gu: 'ઓડિશા',
    ta: 'ஒடிசா', te: 'ఒడిశా', kn: 'ಒಡಿಶಾ',
  },
  Punjab: {
    hi: 'पंजाब', mr: 'पंजाब', gu: 'પંજાબ',
    ta: 'பஞ்சாப்', te: 'పంజాబ్', kn: 'ಪಂಜಾಬ್',
  },
  Rajasthan: {
    hi: 'राजस्थान', mr: 'राजस्थान', gu: 'રાજસ્થાન',
    ta: 'ராஜஸ்தான்', te: 'రాజస్థాన్', kn: 'ರಾಜಸ್ಥಾನ',
  },
  Sikkim: {
    hi: 'सिक्किम', mr: 'सिक्कीम', gu: 'સિક્કિમ',
    ta: 'சிக்கிம்', te: 'సిక్కిం', kn: 'ಸಿಕ್ಕಿಂ',
  },
  'Tamil Nadu': {
    hi: 'तमिलनाडु', mr: 'तमिळनाडू', gu: 'તમિલનાડુ',
    ta: 'தமிழ்நாடு', te: 'తమిళనాడు', kn: 'ತಮಿಳುನಾಡು',
  },
  Telangana: {
    hi: 'तेलंगाना', mr: 'तेलंगणा', gu: 'તેલંગાણા',
    ta: 'தெலங்கானா', te: 'తెలంగాణ', kn: 'ತೆಲಂಗಾಣ',
  },
  Tripura: {
    hi: 'त्रिपुरा', mr: 'त्रिपुरा', gu: 'ત્રિપુરા',
    ta: 'திரிபுரா', te: 'త్రిపుర', kn: 'ತ್ರಿಪುರ',
  },
  'Uttar Pradesh': {
    hi: 'उत्तर प्रदेश', mr: 'उत्तर प्रदेश', gu: 'ઉત્તર પ્રદેશ',
    ta: 'உத்தரப் பிரதேசம்', te: 'ఉత్తర ప్రదేశ్', kn: 'ಉತ್ತರ ಪ್ರದೇಶ',
  },
  Uttarakhand: {
    hi: 'उत्तराखंड', mr: 'उत्तराखंड', gu: 'ઉત્તરાખંડ',
    ta: 'உத்தராகண்ட்', te: 'ఉత్తరాఖండ్', kn: 'ಉತ್ತರಾಖಂಡ',
  },
  'West Bengal': {
    hi: 'पश्चिम बंगाल', mr: 'पश्चिम बंगाल', gu: 'પશ્ચિમ બંગાળ',
    ta: 'மேற்கு வங்காளம்', te: 'పశ్చిమ బెంగాల్', kn: 'ಪಶ್ಚಿಮ ಬಂಗಾಳ',
  },
  Chandigarh: {
    hi: 'चंडीगढ़', mr: 'चंदीगड', gu: 'ચંડીગઢ',
    ta: 'சண்டிகர்', te: 'చండీగఢ్', kn: 'ಚಂಡೀಗಢ',
  },
  'Dadra and Nagar Haveli and Daman and Diu': {
    hi: 'दादरा और नगर हवेली और दमन और दीव',
    mr: 'दादरा आणि नगर हवेली आणि दमण आणि दीव',
    gu: 'દાદરા અને નગર હવેલી અને દમણ અને દીવ',
    ta: 'தாத்ரா மற்றும் நகர் ஹவேலி மற்றும் தமன் மற்றும் தியூ',
    te: 'దాద్రా మరియు నగర్ హవేలీ మరియు డామన్ మరియు డయ్యూ',
    kn: 'ದಾದ್ರಾ ಮತ್ತು ನಗರ್ ಹವೇಲಿ ಮತ್ತು ದಮನ್ ಮತ್ತು ದಿಯು',
  },
  Delhi: {
    hi: 'दिल्ली', mr: 'दिल्ली', gu: 'દિલ્હી',
    ta: 'டெல்லி', te: 'ఢిల్లీ', kn: 'ದೆಹಲಿ',
  },
  'Jammu and Kashmir': {
    hi: 'जम्मू और कश्मीर', mr: 'जम्मू आणि काश्मीर', gu: 'જમ્મુ અને કાશ્મીર',
    ta: 'ஜம்மு காஷ்மீர்', te: 'జమ్మూ కాశ్మీర్', kn: 'ಜಮ್ಮು ಮತ್ತು ಕಾಶ್ಮೀರ',
  },
  Ladakh: {
    hi: 'लद्दाख', mr: 'लडाख', gu: 'લડાખ',
    ta: 'லடாக்', te: 'లడఖ్', kn: 'ಲಡಾಖ್',
  },
  Lakshadweep: {
    hi: 'लक्षद्वीप', mr: 'लक्षद्वीप', gu: 'લક્ષદ્વીપ',
    ta: 'இலட்சத்தீவு', te: 'లక్షద్వీప్', kn: 'ಲಕ್ಷದ್ವೀಪ',
  },
  Puducherry: {
    hi: 'पुडुचेरी', mr: 'पुडुचेरी', gu: 'પુડુચેરી',
    ta: 'புதுச்சேரி', te: 'పుదుచ్చేరి', kn: 'ಪುದುಚೇರಿ',
  },
};
